import { render, staticRenderFns } from "./coordinatesEditor.vue?vue&type=template&id=3aeeeb55&scoped=true"
import script from "./coordinatesEditor.vue?vue&type=script&lang=js"
export * from "./coordinatesEditor.vue?vue&type=script&lang=js"
import style0 from "./coordinatesEditor.vue?vue&type=style&index=0&id=3aeeeb55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeeeb55",
  null
  
)

export default component.exports